import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-user-circle",
  "use": "icon-user-circle-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-user-circle\"><path d=\"M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z\" fill=\"#E6E6E6\" p-id=\"826\" /><path d=\"M256 691.2c0-129.6 114.624-211.2 256-211.2s256 81.6 256 211.2-114.624 140.8-256 140.8-256-11.2-256-140.8z m128-371.2a128 128 0 1 1 128 128 128 128 0 0 1-128-128z\" p-id=\"827\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol